export default {"src":"/_next/static/media/error.a768fc1a.svg","height":418,"width":525};